import { uuid } from '@razz-team/utils';
import { useConst } from './useConst';

export function createIdempotencyKey() {
  return uuid();
}

export function useIdempotencyKey() {
  return useConst(createIdempotencyKey);
}
